import React, { useEffect } from 'react';
import {
    TrendingUp, Coins, Leaf, Truck, Crop, Microscope,
    CheckCircle, LifeBuoy, ShieldCheck, Users
} from 'lucide-react';
import './BenefitsDetails.css';

// Benefits data structure
const benefitsData = [
    {
        title: 'Increased Productivity',
        icon: <TrendingUp size={28} />,
        details: [
            'Advanced Machinery: Leveraging GPS-guided tractors and automated irrigation.',
            'Precision Farming: Data-driven techniques to optimize planting and fertilization.',
            'Expert Agronomy: Access to specialists for soil health and crop quality optimization.',
        ],
    },
    {
        title: 'Cost-Effective Solutions',
        icon: <Coins size={28} />,
        details: [
            'Economies of Scale: Reduced per-unit costs through bulk commercial production.',
            'Flexible Packages: Custom service options tailored to specific budget needs.',
            'Operational Efficiency: Minimized resource waste in water, labor, and energy.',
        ],
    },
    {
        title: 'Sustainability & Eco-Friendly',
        icon: <Leaf size={28} />,
        details: [
            'Organic Methods: Integrated pest management and chemical-free practices.',
            'Water Conservation: Drip irrigation and smart water management systems.',
            'Soil Health: Regular testing to maintain fertility and prevent degradation.',
        ],
    },
    {
        title: 'Reliable Supply Chain',
        icon: <Truck size={28} />,
        details: [
            'Consistent Output: Guaranteed large-scale reliability for retailers and markets.',
            'Efficient Logistics: Optimized storage and transportation for freshness.',
            'Contract Farming: Secured long-term agreements for price stability.',
        ],
    },
    {
        title: 'Sector-Specific Solutions',
        icon: <Crop size={28} />,
        details: [
            'Crop Diversification: Serving food, biofuel, and livestock feed sectors.',
            'Farm-to-Market: Direct channels to consumers and food processors.',
            'End-to-End Management: From land prep to post-harvest processing.',
        ],
    },
    {
        title: 'Research & Innovation',
        icon: <Microscope size={28} />,
        details: [
            'R&D Investment: Continuous improvement of crop varieties and resilience.',
            'Smart Technology: AI and IoT integration for real-time monitoring.',
        ],
    },
    {
        title: 'Compliance & Standards',
        icon: <CheckCircle size={28} />,
        details: [
            'Certified Quality: Adhering to local and international safety standards.',
            'Start-to-End Traceability: Full visibility from farm origin to final table.',
        ],
    },
    {
        title: 'Expert Support',
        icon: <LifeBuoy size={28} />,
        details: [
            '24/7 Consultation: ongoing technical assistance and troubleshooting.',
            'Training Programs: Workshops on the latest sustainable tech.',
        ],
    },
    {
        title: 'Risk Management',
        icon: <ShieldCheck size={28} />,
        details: [
            'Climate Resilience: Strategies to mitigate weather-related risks.',
            'Crop Insurance: Safety nets against unforeseen disasters.',
        ],
    },
    {
        title: 'Community Impact',
        icon: <Users size={28} />,
        details: [
            'Job Creation: Employment in farming, logistics, and processing.',
            'Local Economy: Uplifting rural communities through development projects.',
        ],
    },
];

const BenefitsDetails = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bd-premium-page">

            <div className="bd-hero">
                <div className="bd-hero-content">
                    <span className="bd-hero-badge">Why Choose Us</span>
                    <h1 className="bd-hero-title">Detailed Benefits</h1>
                    <p className="bd-hero-subtitle">
                        Discover how our comprehensive agricultural solutions drive value,
                        sustainability, and growth for your business.
                    </p>
                </div>
            </div>

            <div className="bd-container">
                <div className="bd-grid">
                    {benefitsData.map((benefit, index) => (
                        <div key={index} className="bd-card">
                            <div className="bd-card-header">
                                <div className="bd-icon-box">
                                    {benefit.icon}
                                </div>
                                <h3 className="bd-card-title">{benefit.title}</h3>
                            </div>
                            <ul className="bd-list">
                                {benefit.details.map((detail, i) => (
                                    <li key={i}>{detail}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>

            <div className="bd-footer-tag">Emerging Farmers Empowerment</div>
        </div>
    );
};

export default BenefitsDetails;
